import { useContext } from 'react';

// import firebaseConfig from '../config/firebaseConfig';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

import { connectAuthEmulator } from 'firebase/auth';
import { AuthContextType } from '../provider/types/authContextType';
import { AuthContext } from '../provider/AuthProvider';


// // initialize firebase
// const firebaseApp = initializeApp(firebaseConfig);
// const auth = getAuth(firebaseApp);

// // Use Firebase emulitaer for local development
// if (process.env.REACT_APP_NODE_ENV === 'development') {
//     console.log('Using Firebase emulator');
//     connectAuthEmulator(auth, 'http://localhost:9099');
// }

const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
};

export default useAuth;